import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

import { useDispatch, useStore } from 'react-redux'
import { Modal } from 'rsuite'
import { ReactComponent as SearchIcon } from '../../assets/svg/search-icon.svg'
import { ReactComponent as RecentlyViewedIcon } from '../../assets/svg/recently-viewed-icon.svg'
import { FiChevronRight } from 'react-icons/fi'

import SearchCategoryModal from './category-modal'
import { addRecentlyViewedResult, updateRecentlyViewedResult, addRecentKeyword, updateRecentKeyword } from '../../redux/actions/user'
import LoaderComponent from '../CommonComponents/LoaderComponent'
import { sortGlobalSearchResults } from '../../services/helper'

const categoryList = [
    {
        label: 'All Categories',
        value: 'all'
    },
    {
        label: 'Master Suppliers',
        value: 'master'
    },
    {
        label: 'Related Suppliers',
        value: 'related'
    },
    {
        label: 'Lists',
        value: 'lists'
    },
    {
        label: 'Domains',
        value: 'domains'
    },
    {
        label: 'Contacts',
        value: 'contacts'
    }
]

const SearchComponent = ({ isLoader, searchKeyword = '', openModal = false, onModalClose, filteredData, recentViewedSearchdData, allSuppliers, recentKeywords, onRecentKeywordClick }) => {
    const store = useStore().getState()
    const dispatch = useDispatch()
    const {
        auth
    } = store

    const { user } = auth
    const [showSearchhModal, setShowSearchhModal] = useState(openModal)
    const [searchData, setSearchData] = useState([])
    const [currentCategory, setCurrentCategory] = useState('all')
    const [selectedResult, setSelectedResult] = useState(null)
    const [recentlyViewedSearchdData, setRecentlyViewedSearchdData] = useState(recentViewedSearchdData)
    const [recentKeywordsData, setRecentKeywordsData] = useState(recentKeywords)
    const [modalTitle, setModalTitle] = useState('All Search Results')

    useEffect(() => {
        if (!filteredData) {
            setSearchData([])
            return
        }
        onTabChange(currentCategory)
    }, [filteredData])

    const onClose = () => {
        onModalClose()
    }

    const onTabChange = (tab) => {
        var data = [];
        var viewedData = [];
        var tabChangeData = {}
        viewedData = tab !== 'all' ? recentViewedSearchdData.filter(val => {
            return val?.ResultType === tab
        }) : recentViewedSearchdData

        var modalTitle = 'Search Results For '

        tabChangeData = tab === 'master' ? {
            data: filteredData?.suppliers?.filter(value => {
                return value?.isMaster
            }),
            modalTitle: modalTitle + 'Master Suppliers'

        } : tab === 'related' ? {
            data: filteredData?.suppliers?.filter(value => {
                return !value?.isMaster
            }),
            modalTitle: modalTitle + 'Related Suppliers'
        } : tab === 'lists' ? {
            data: [],
            modalTitle: modalTitle + 'Lists'
        } : tab === 'domains' ? {
            data: [],
            modalTitle: modalTitle + 'Domains'
        } : tab === 'contacts' ? {
            data: filteredData?.contacts || [],
            modalTitle: modalTitle + 'Contacts'
        } : {
            data: [...filteredData?.suppliers, ...filteredData?.contacts],
            modalTitle: 'All Search Results'
        }

        // sorting isMaster true and supplier results on top
        if (tabChangeData?.data && tabChangeData?.data?.length > 0) {
            tabChangeData.data = sortGlobalSearchResults(tabChangeData?.data)
        }
        if (viewedData && viewedData?.length > 0) {
            viewedData = sortGlobalSearchResults(viewedData)
        }

        setSearchData(tabChangeData?.data)
        setCurrentCategory(tab)
        setRecentlyViewedSearchdData(viewedData)
        setModalTitle(tabChangeData?.modalTitle)
    }

    const handleSearchResultClick = async (value) => {
        const userId = user?.id
        let resType = ''
        if (value?.hasOwnProperty('contactName')) {
            resType = 'contact'
        } else {
            resType = value?.isMaster ? 'master' : !value?.isMaster ? 'related' : ''
        }
        setSelectedResult(value?.id)
        var isRecord = recentViewedSearchdData.filter(val => {
            return val?.viewedResultId === value?.id && val?.ResultType === resType && val?.userId === userId
        })
        var iskeywordRecord = recentKeywords.filter(keywordData => {
            return keywordData?.keyword.trim() === searchKeyword.trim()
        })

        if (isRecord.length > 0) {
            await dispatch(updateRecentlyViewedResult({
                resultId: value?.id,
                resultType: resType
            }))
        } else {
            await dispatch(addRecentlyViewedResult({
                resultId: value?.id,
                resultType: resType
            }))
        }

        if (iskeywordRecord.length > 0) {
            await dispatch(updateRecentKeyword({
                keyword: searchKeyword.trim(),
                categoryType: currentCategory,
                rowId: iskeywordRecord?.[0]?.id
            }))
        } else {
            await dispatch(addRecentKeyword({
                keyword: searchKeyword.trim(),
                categoryType: currentCategory
            }))
        }
    }

    const handleRecentKeywordClick = (value) => {
        onRecentKeywordClick(value)
        setCurrentCategory(value?.categoryType)
    }

    return (
        <>
            <div className='search-modal-parent'>
                <Modal
                    backdrop={true}
                    className="search-modal"
                    show={showSearchhModal}
                    size="sm"
                    onHide={onClose}
                    autoFocus={false}
                >
                    <Modal.Header>
                        <h4 className='search-modal-title flex align-center'><SearchIcon /> {searchKeyword}</h4>
                    </Modal.Header>
                    <Modal.Body className='search-modal-body mt-4 pb-0'>
                        {searchKeyword === '' ?
                            <>
                                <div className='recent-keywords'>
                                    <h4 className='title'> Recent Keywords </h4>
                                    <div className='recent-keywords-content'>
                                        {recentKeywordsData.length > 0 ? recentKeywordsData.map(value => {
                                            return (
                                                <div key={value?.id} className={`recent-keywords-inner-parent flex justify-space-between align-center ${selectedResult === value?.id ? 'selected' : ''}`} onClick={() => { handleRecentKeywordClick(value) }}>
                                                    <div className='recent-keywords-inner flex'>
                                                        <SearchIcon />
                                                        <h4 className='keyword-name mb-0'>
                                                            "{value?.keyword}"
                                                            <p className='category mb-0'>
                                                                {value?.categoryType === 'master' ? 'Master Suppliers' : value?.categoryType === 'related' ? 'Related Suppliers' : 'All Categories'}
                                                            </p>
                                                        </h4>
                                                    </div>
                                                    <FiChevronRight color="#D9D9D9" size={26} />
                                                </div>
                                            )
                                        }) :
                                            <h4 className='no-data text-black'> No Recent Keywords found. </h4>
                                        }
                                    </div>
                                </div>
                                <div className='recently-viewed'>
                                    <h4 className='title'> Recently Viewed </h4>
                                    <div className='recently-viewed-content'>
                                        {recentlyViewedSearchdData.length > 0 ? recentlyViewedSearchdData.map((val) => {
                                            let url = ''
                                            let catTitle = ''
                                            if (val?.ResultType === 'contact') {
                                                url = '/contacts/' + val?.viewedResultId
                                                catTitle = val?.contactName?.trim() || 'Unknown'
                                            }
                                            if (val?.ResultType === 'master' || val?.ResultType === 'related') {
                                                url = val?.isMaster && !val?.masterId ? '/suppliers/' + val?.viewedResultId : '/suppliers/relatedsupplier/' + val?.viewedResultId
                                                catTitle = val?.suppliername
                                            }
                                            let resType = val?.ResultType === 'master' ? 'Master Supplier' : val?.ResultType === 'related' ? 'Related Supplier' : val?.ResultType === 'contact' ? 'Contact' : val?.ResultType === 'all' ? 'All Categories' : ''
                                            return (
                                                <Link target="_blank" key={val?.viewedResultId} to={url} className='search-result-link text-decoration-none'>
                                                    <div className='recently-viewed-inner-parent flex justify-space-between align-center'>
                                                        <div className='recently-viewed-inner flex'>
                                                            <RecentlyViewedIcon />
                                                            <h4 className='mb-0'>
                                                                {catTitle}
                                                                <p className='category mb-0'>
                                                                    {resType}
                                                                </p>
                                                            </h4>
                                                        </div>
                                                        <FiChevronRight color="#D9D9D9" size={26} />
                                                    </div>
                                                </Link>
                                            )
                                        }) :
                                            <h4 className='no-data text-black'> No Recently Viewed Search Results found. </h4>
                                        }
                                    </div>
                                </div>
                            </>
                            :
                            <>
                                <div className='recent-keywords search-results'>
                                    <h4 className='title'> {modalTitle} </h4>
                                    <div className='recent-keywords-content search-results-content'>
                                        {/* {isLoader && <LoaderComponent /> } */}
                                        {isLoader ? <LoaderComponent /> : searchData?.length > 0 ? searchData?.map(value => {
                                            let url = ''
                                            let catTitle = ''
                                            let resType = ''
                                            if (value?.hasOwnProperty('contactName')) {
                                                url = '/contacts/' + value?.id
                                                resType = 'Contact'
                                                catTitle = value?.contactName?.trim() || 'Unknown'
                                            } else {
                                                url = value?.isMaster && !value?.masterId ? '/suppliers/' + value?.id : '/suppliers/relatedsupplier/' + value?.id
                                                resType = value?.isMaster ? 'Master Supplier' : !value?.isMaster ? 'Related Supplier' : ''
                                                catTitle = value?.suppliername
                                            }
                                            return (
                                                <Link target="_blank" key={value?.id} to={url} className='search-result-link text-decoration-none'>
                                                    <div key={value?.id} className={`recent-keywords-inner-parent flex justify-space-between align-center ${selectedResult === value?.id ? 'selected' : ''}`} onClick={() => { handleSearchResultClick(value) }}>
                                                        <div className='recent-keywords-inner flex'>
                                                            <SearchIcon />
                                                            <h4 className='mb-0'>
                                                                {catTitle}
                                                                <p className='category mb-0'>
                                                                    {resType}
                                                                    {/* {currentCategory === 'master' ? 'Master Suppliers' : currentCategory === 'related' ? 'Related Suppliers' : 'All Categories'} */}
                                                                </p>
                                                            </h4>
                                                        </div>
                                                        <FiChevronRight className='search-right-icon' color={`${selectedResult === value?.id ? '#214466' : '#D9D9D9'}`} size={26} />
                                                    </div>
                                                </Link>
                                            )
                                        }) :
                                            <h4 className='no-data text-black'> No Search data found. </h4>
                                        }
                                    </div>
                                </div>
                            </>
                        }

                    </Modal.Body>
                    {searchKeyword && (
                        <SearchCategoryModal categoryList={categoryList} searchKeyword={searchKeyword} currentCategory={currentCategory} onTabChange={onTabChange} />
                    )}
                </Modal>
            </div>
        </>
    )
}

export default SearchComponent;